import { z } from 'zod';
export const createScheduleSchema = z.object({
    opposition_id: z.string().uuid(),
    // null/omitted ⇒ horario COMÚN a todos los turnos de la oposición (p. ej.
    // psicotécnicos). Un uuid ⇒ horario de ese turno concreto.
    shift_id: z.string().uuid().nullish(),
    month: z.number().int().min(1).max(12),
    year: z.number().int().min(2020).max(2100),
    notes: z.string().max(500).optional(),
});
export const updateScheduleSchema = z.object({
    notes: z.string().max(500).optional(),
});
const scheduleClassBaseSchema = z.object({
    subject_id: z.string().uuid(),
    professor_id: z.string().uuid(),
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha inválida (YYYY-MM-DD)'),
    start_time: z.string().regex(/^\d{2}:\d{2}$/, 'Hora inválida (HH:mm)'),
    end_time: z.string().regex(/^\d{2}:\d{2}$/, 'Hora inválida (HH:mm)'),
    classroom: z.string().max(100).optional(),
    notes: z.string().max(500).optional(),
});
export const createScheduleClassSchema = scheduleClassBaseSchema.refine((d) => d.end_time > d.start_time, { message: 'La hora de fin debe ser posterior a la hora de inicio', path: ['end_time'] });
export const updateScheduleClassSchema = scheduleClassBaseSchema
    .partial()
    .refine((d) => !d.start_time || !d.end_time || d.end_time > d.start_time, {
    message: 'La hora de fin debe ser posterior a la hora de inicio',
    path: ['end_time'],
});
export const bulkCreateScheduleClassesSchema = z.object({
    classes: z.array(createScheduleClassSchema).min(1).max(50),
});
//# sourceMappingURL=schedule.schema.js.map